<ul class="layout-menu mt-3">

    <ng-container *ngFor="let item of model; let i = index;">
        <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true" [class.mx-2]="layoutService.state.staticMenuDesktopInactive"></li>
        <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
</ul>
